"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalIcon = _interopRequireDefault(require("@/libs/modal-icon"));
var _modalParserFrom = _interopRequireDefault(require("@/libs/modal-parserFrom"));
var _modalSure = _interopRequireDefault(require("@/libs/modal-sure"));
var _modalPrompt = _interopRequireDefault(require("@/libs/modal-prompt"));
var _timeOptions = _interopRequireDefault(require("@/libs/timeOptions"));
var _dialog = _interopRequireDefault(require("@/libs/dialog"));
var constants = _interopRequireWildcard(require("@/utils/constants.js"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var Auth = _interopRequireWildcard(require("@/libs/wechat"));
var _asyncValidator = _interopRequireDefault(require("async-validator"));
var _parsing = require("@/utils/parsing");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
//import modalCoupon from '@/libs/modal-coupon';
var _default = exports.default = {
  install: function install(Vue) {
    Vue.prototype.$modalSure = _modalSure.default;
    Vue.prototype.$modalIcon = _modalIcon.default;
    Vue.prototype.$modalParserFrom = _modalParserFrom.default;
    Vue.prototype.$timeOptions = _timeOptions.default;
    Vue.prototype.$constants = constants;
    Vue.prototype.$selfUtil = selfUtil;
    Vue.prototype.handleTree = _parsing.handleTree;
    Vue.prototype.parseTime = _parsing.parseTime;
    Vue.prototype.resetForm = _parsing.resetForm;
    Vue.prototype.$dialog = _dialog.default;
    Vue.prototype.$scroll = scroll;
    Vue.prototype.$wechat = Auth;
    Vue.prototype.$modalPrompt = _modalPrompt.default;
    //Vue.prototype.$modalCoupon= modalCoupon;
    Vue.prototype.$validator = function (rule) {
      return new _asyncValidator.default(rule);
    };
  }
};